export const CREATE = "CREATE";
export const DELETE = "DELETE";
export const UPDATE = "UPDATE";
export const FETCH_ALL = "FETCH_ALL";
export const SET_USER = "SET_USER";
export const DEL_USER = "DEL_USER";
